import React, { FormEvent } from "react";
import { Link } from "react-router-dom";
import blog3 from "../../images/blog-details/comments-author/img-1.jpg";
import blog4 from '../../images/blog-details/comments-author/img-2.jpg'
import blog5 from "../../images/blog-details/comments-author/img-3.jpg";
import gl1 from "../../images/blog-details/img-2.jpg";
import gl2 from "../../images/blog-details/img-3.jpg";
import { Blog } from "../../api/blogs";
import BlogSidebar from "../BlogSidebar/BlogSidebar";

interface BlogSingleProps {
  blog?: Blog; // blog is optional for safety
  pageStyle?: string;
  blLeft?: boolean;
}

const BlogSingle: React.FC<BlogSingleProps> = ({ blog, pageStyle, blLeft }) => {
  const submitHandler = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  // ✅ Handle no blog found
  if (!blog) {
    return (
      <section className={`wpo-blog-single-section ${pageStyle || ""}`}>
        <div className="container text-center py-5">
          <h2>Blog not found 😢</h2>
          <Link to="/blog" className="theme-btn mt-3">
            Back to Blog
          </Link>
        </div>
      </section>
    );
  }

  return (
    <section
      className={`wpo-blog-single-section ${pageStyle || ""} section-padding`}
    >
      <div className="container-fluid">
        <div className="wpo-blog-wraper">
          <div className="wpo-blog-content">
            {/* Blog Post Content */}
            <article className="post format-standard-image">
              <div className="entry-media">
                <img src={blog.blogSingleImg} alt={blog.title} />
              </div>

              <div className="entry-meta">
                <ul>
                  <li>
                    By: <Link to="/blog">{blog.author}</Link>
                  </li>
                  <li>Date: {blog.create_at}</li>
                </ul>
              </div>

              <div className="entry-body">
                <p>
                  <span>W</span>edding is more than a celebration—it’s the
                  beginning of a lifelong journey together. Every detail, from
                  the soft glow of candles to the beauty of the gown, creates
                  moments that will be treasured forever.
                </p>

                <blockquote>
                  Making Every Wedding Moment Count: Elegant Ideas for Small
                  Celebrations
                  <h4>
                    - Cameron Williamson,{" "}
                    <span>Senior Interior Designer</span>
                  </h4>
                </blockquote>

                <h2>"Your dream wedding begins with the perfect inspiration."</h2>

                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard dummy text ever since the 1500s.
                </p>

                <div className="gallery">
                  <div>
                    <img src={gl1} alt="Gallery 1" />
                  </div>
                  <div>
                    <img src={gl2} alt="Gallery 2" />
                  </div>
                </div>
              </div>
            </article>

            {/* Tags + Share */}
            <div className="tag-wrap">
              <div className="tag-share-s2">
                <div className="tag">
                  <span>Share Article:</span>
                  <ul>
                    <li>
                      <Link to="#">
                        <i className="ti-facebook"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="ti-twitter-alt"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="ti-linkedin"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="ti-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="tag-share">
                <div className="tag">
                  <span>Tags:</span>
                  <ul>
                    <li>
                      <Link to="#">wedding</Link>
                    </li>
                    <li>
                      <Link to="#">photography</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Previous / Next Posts */}
            <div className="more-posts">
              <div className="previous-post">
                <Link to="/blog/previous-post">
                  <span className="post-control-link">Previous Post</span>
                  <span className="post-name">
                    Compact Celebrations, Grand Ideas: Making Every Wedding
                    Moment Count
                  </span>
                </Link>
              </div>
              <div className="next-post">
                <Link to="/blog/next-post">
                  <span className="post-control-link">Next Post</span>
                  <span className="post-name">
                    10 Memorable Weddings That Changed How We Celebrate Love
                  </span>
                </Link>
              </div>
            </div>

            {/* Comments Section */}
            <div className="comments-area">
              <div className="comments-section">
                <h3 className="comments-title">Comments:</h3>
                <ol className="comments">
                  <li className="comment even thread-even depth-1" id="comment-1">
                    <div id="div-comment-1">
                      <div className="comment-theme">
                        <div className="comment-image"><img
                          src={blog3} alt="" />
                        </div>
                      </div>
                      <div className="comment-main-area">
                        <div className="comment-wrapper">
                          <div className="comments-meta">
                            <h4>Kristin Watson</h4>
                            <span className="comments-date">Founder Of Megan</span>
                          </div>
                          <div className="comment-area">
                            <p>Turpis nulla proin donec a ridiculus. Mi suspendisse faucibus
                              sed lacus. Vitae risus eu nullam sed quam. Eget aenean id
                              augue pellentesque turpis magna egestas arcu sed. Turpis
                              integer aliquam aliquam aliquam.
                              <Link className="comment-reply-link" to="/blog">Reply...</Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul className="children">
                      <li className="comment">
                        <div>
                          <div className="comment-theme">
                            <div className="comment-image"><img
                              src={blog4}
                              alt="" />
                            </div>
                          </div>
                          <div className="comment-main-area">
                            <div className="comment-wrapper">
                              <div className="comments-meta">
                                <h4>Cody Fisher</h4>
                                <span className="comments-date">Interior Designer</span>
                              </div>
                              <div className="comment-area">
                                <p>Vitae risus eu nullam sed quam. Eget aenean id augue
                                  pellentesque turpis magna egestas arcu sed. Turpis
                                  integer aliquam aliquam aliquam.
                                  <Link className="comment-reply-link" to="/blog">Reply...</Link>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                      <li>
                        <span className="shape">
                          <svg width="107" height="261" viewBox="0 0 107 261" fill="none">
                            <path d="M1 0V240C1 251.046 9.9543 260 21 260H107"
                              stroke="#D9D9D9" />
                          </svg>
                        </span>
                      </li>
                    </ul>
                  </li>
                  <li className="comment">
                    <div>
                      <div className="comment-theme">
                        <div className="comment-image"><img
                          src={blog5} alt="" />
                        </div>
                      </div>
                      <div className="comment-main-area">
                        <div className="comment-wrapper">
                          <div className="comments-meta">
                            <h4>Kristin Watson</h4>
                            <span className="comments-date">Founder Of Megan</span>
                          </div>
                          <div className="comment-area">
                            <p>Turpis nulla proin donec a ridiculus. Mi suspendisse faucibus
                              sed lacus. Vitae risus eu nullam sed quam. Eget aenean id
                              augue pellentesque turpis magna egestas arcu sed. Turpis
                              integer aliquam aliquam aliquam.
                              <Link className="comment-reply-link" to="/blog">Reply...</Link>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ol>
              </div>

              {/* Comment Form */}
              <div className="comment-respond">
                <h3 className="comment-reply-title">Leave a comment:</h3>
                <form className="comment-form" onSubmit={submitHandler}>
                  <div className="form-inputs">
                    <input placeholder="Name:" name="name" type="text" required />
                    <input
                      placeholder="Email:"
                      name="email"
                      type="email"
                      required
                    />
                  </div>
                  <div className="form-textarea">
                    <textarea
                      id="comment"
                      name="message"
                      placeholder="Message here..."
                      required
                    ></textarea>
                  </div>
                  <div className="form-submit">
                    <input id="submit" className="theme-btn" value="GET A QUOTE" type="submit" />
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <BlogSidebar blLeft={blLeft} />
        </div>
      </div>
    </section>
  );
};

export default BlogSingle;
